import Vue from 'vue'

require('./components/index.js')

const App = new Vue({
	el : '#app'
});


// WEBPACK FOOTER //
// ./src/assets/vue/main.js